import React, {Component} from 'react';
import styles from '../css/AuditTrail.module.css';
import AuditTrailResult from './AuditTrailResult'
import Axios from './../../../components/Axios'

class AuditTrail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loaded: false,
            edit: false,
            editIndex: -1,
            data: []
        };
    }

    componentDidMount() {
        let temp = {}
        temp.state = this.state
        Axios('/api/v1/admin/get-audit-trail', temp, (data) => {
            this.setState({
                loaded: true,
                data: data
            })
            //this.props.setData(data)
        })
    }

    componentDidUpdate(prevProps, prevState) {
        //if (prevProps.data !== this.props.data) {
        //    this.setState({data: this.props.data});
        //}
    }

    edit(i) {
        this.props.changeAdminView(7, this.state.data[i])
    }

    delete(i) {
        this.props.changeAdminView(8, this.state.data[i])
    }

    close() {
        this.setState({editIndex: -1})
    }

    setData(d) {
        this.setState({data: d})
    }

    changeView(i) {
        this.setState({editIndex: i})
    }

    render() {
        let results = []
        if (this.state.data) {
            for (let i = 0; i < this.state.data.length; i++) {
                results.push(<AuditTrailResult key={i} data={this.state.data[i]} setData={this.setData.bind(this)} close={this.close.bind(this)} edit={this.edit.bind(this)} delete={this.delete.bind(this)} number={i}/>)
            }
        }
        return (
            <div className={styles.AuditTrail}>
                
                <div className={styles.blueBar}>System Audit Trail</div>
                <div className={styles.history}>
                    <div className={styles.resultTitles}>
                        <div>USER</div>
                        <div>EVENT</div>
                        <div>DATE</div>
                        <div>DESCRIPTION</div>
                        <div>FULL REQUEST</div>
                    </div>
                    <div className={styles.results}>
                        {this.state.loaded ? results : "Loading . . ."}
                    </div>
                </div>
            </div>
        );
    }
}

export default AuditTrail;
